import toDate from "../toDate/index.mjs";
import endOfDay from "../endOfDay/index.mjs";
import endOfMonth from "../endOfMonth/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}
export {
  isLastDayOfMonth as default
};
